import { Navigate, useLocation } from "react-router-dom";

/** MNT-4: an old maintenance path becomes its application's tab, keeping whatever the address was carrying (a function, an area, a client filter). */
export const RedirectToTab = ({ slug, tab }: { slug: string; tab: string }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set("tab", tab);
  return <Navigate to={`/admin/apps/${slug}?${params.toString()}`} replace />;
};
